import React from "react";
import { PageSeo } from "../components/PageSeo";
import { GallerySection } from "../components/GallerySection";

export function GalerijaPage() {
  return (
    <>
      <PageSeo
        title="Galerija | RESTORAN KRČMA Kragujevac"
        description="Galerija restorana KRČMA: ambijent, jela, banket sala i prenoćište u Kragujevcu."
        keywords="restoran Kragujevac galerija, banket sala Kragujevac slike, prenoćište Kragujevac slike"
        path="/galerija"
      />
      <GallerySection />
    </>
  );
}

